// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"bR-z","smallCardRow":"cR-z","largeCardRow":"dR-z","productSearchRow":"eR-z","curatedRow":"fR-z"};